import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Crochet World',
    tagline: 'Handmade with Love',
    description: 'Step inside a cosy 3D boutique of handmade crochet dolls. Teddy bears, bunnies, keychains, custom portraits, and limited-edition amigurumi, each stitched by hand and ordered easily on WhatsApp.',
    url: getOrigin()
}

// Digits only, international format (for example 62812...). Set in the Secrets tab.
export const WHATSAPP_NUMBER_RAW = process.env.NEXT_PUBLIC_WHATSAPP_NUMBER ?? ''

export const NAV_LINKS = [
    { href: '/', label: 'Boutique' },
    { href: '/shop', label: 'Shop all' },
    { href: '/shop?category=limited-edition', label: 'Limited Edition' },
    { href: '/shop?category=custom-crochet-dolls', label: 'Custom Dolls' }
]

export const PRICE_RANGES = [
    { id: 'under-100', label: 'Under Rp 100.000', min: 0, max: 99999 },
    { id: '100-250', label: 'Rp 100.000 to 250.000', min: 100000, max: 250000 },
    { id: '250-400', label: 'Rp 250.000 to 400.000', min: 250001, max: 400000 },
    { id: 'over-400', label: 'Above Rp 400.000', min: 400001, max: null }
]

export const SORT_OPTIONS = [
    { id: 'featured', label: 'Featured' },
    { id: 'newest', label: 'Newest' },
    { id: 'price-asc', label: 'Price: low to high' },
    { id: 'price-desc', label: 'Price: high to low' },
    { id: 'name', label: 'Name: A to Z' }
]
